import React from "react";

import {
  MdFormatBold,
  MdFormatItalic,
  MdFormatUnderlined,
  MdFormatListBulleted,
  MdFormatListNumbered,
  MdInsertLink,
} from "react-icons/md";

import { Tooltip } from "antd";
import H1TipTap from "components/TipTapEditor/HeadingIcons/H1TipTap";
import H2TipTap from "components/TipTapEditor/HeadingIcons/H2TipTap";
import H3TipTap from "components/TipTapEditor/HeadingIcons/H3TipTap";
import useUniversalTipTapMenuBar from "./hooks/useUniversalTipTapMenuBar";
import cx from "classnames";

import "./index.scss";

const UniversalTipTapMenubar = (props) => {
  const { link, bold, italic, underline, bulletList, orderedList, h1, h2, h3 } =
    props;
  const {
    editor,
    className,
    showLinkModal,
    isMac,
    checkIfActiveOrNot,
    menubarActionSize,
    showTextActions,
    showBulletLists,
    showLink,
    showHeadingActions,
  } = useUniversalTipTapMenuBar(props);

  const defaultTooltips = {
    bold: bold || `Bold (${isMac ? "Cmd+B" : "Ctrl+B"})`,
    italic: italic || `Italic (${isMac ? "Cmd+I" : "Ctrl+I"})`,
    underline: underline || `Underline (${isMac ? "Cmd+U" : "Ctrl+U"})`,
    orderedList:
      orderedList || `Ordered list (${isMac ? "Cmd+Shift+7" : "Ctrl+Shift+7"})`,
    bulletList:
      bulletList || `Bullet list (${isMac ? "Cmd+Shift+8" : "Ctrl+Shift+8"})`,
    link: link || "Link",
    h1: h1 || `Heading 1 (${isMac ? "Cmd+Alt+1" : "Ctrl+Alt+1"})`,
    h2: h2 || `Heading 2 (${isMac ? "Cmd+Alt+2" : "Ctrl+Alt+2"})`,
    h3: h3 || `Heading 3 (${isMac ? "Cmd+Alt+3" : "Ctrl+Alt+3"})`,
  };

  return (
    <div className={`universal-menubar ${className}`}>
      {showHeadingActions && (
        <>
          <Tooltip title={defaultTooltips.h1}>
            <H1TipTap isMac={isMac} editor={editor} height={15} width={15} />
          </Tooltip>
          <Tooltip title={defaultTooltips.h2}>
            <H2TipTap isMac={isMac} editor={editor} height={15} width={15} />
          </Tooltip>
          <Tooltip title={defaultTooltips.h3}>
            <H3TipTap isMac={isMac} editor={editor} height={15} width={15} />
          </Tooltip>
        </>
      )}

      {showTextActions && (
        <>
          <Tooltip title={defaultTooltips.bold}>
            <MdFormatBold
              className={cx("cursor-pointer text-action-style", {
                "active-text-action": editor?.isActive("bold"),
              })}
              style={{ width: menubarActionSize, height: menubarActionSize }}
              fill={checkIfActiveOrNot("bold")}
              onClick={() => editor.chain().focus().toggleBold().run()}
            />
          </Tooltip>
          <Tooltip title={defaultTooltips.italic}>
            <MdFormatItalic
              className={cx("cursor-pointer text-action-style", {
                "active-text-action": editor?.isActive("italic"),
              })}
              style={{ width: menubarActionSize, height: menubarActionSize }}
              fill={checkIfActiveOrNot("italic")}
              onClick={() => editor.chain().focus().toggleItalic().run()}
            />
          </Tooltip>
          <Tooltip title={defaultTooltips.underline}>
            <MdFormatUnderlined
              className={cx("cursor-pointer text-action-style", {
                "active-text-action": editor?.isActive("underline"),
              })}
              style={{ width: menubarActionSize, height: menubarActionSize }}
              onClick={() => editor.chain().focus().toggleUnderline().run()}
              fill={checkIfActiveOrNot("underline")}
            />
          </Tooltip>
        </>
      )}

      {showBulletLists && (
        <>
          <Tooltip title={defaultTooltips.orderedList}>
            <MdFormatListNumbered
              className={cx("cursor-pointer text-action-style", {
                "active-text-action": editor?.isActive("orderedList"),
              })}
              style={{ width: menubarActionSize, height: menubarActionSize }}
              onClick={() => editor.chain().focus().toggleOrderedList().run()}
              fill={checkIfActiveOrNot("orderedList")}
            />
          </Tooltip>
          <Tooltip title={defaultTooltips.bulletList}>
            <MdFormatListBulleted
              className={cx("cursor-pointer text-action-style", {
                "active-text-action": editor?.isActive("bulletList"),
              })}
              style={{ width: menubarActionSize, height: menubarActionSize }}
              onClick={() => editor.chain().focus().toggleBulletList().run()}
              fill={checkIfActiveOrNot("bulletList")}
            />
          </Tooltip>
        </>
      )}

      {showLink && (
        <Tooltip title={defaultTooltips.link}>
          <MdInsertLink
            onClick={() => {
              showLinkModal();
            }}
            className={cx("cursor-pointer text-action-style", {
              "active-text-action": editor?.isActive("link"),
            })}
            style={{ width: menubarActionSize, height: menubarActionSize }}
            fill={checkIfActiveOrNot("link")}
          />
        </Tooltip>
      )}
    </div>
  );
};

export default UniversalTipTapMenubar;
